import React, { memo } from "react";

export const IconButton = memo(
  ({ financeDrawer, style, loading, className, children, ...rest }) => {
    return (
      <button
        className={
          financeDrawer && financeDrawer === "financeDrawer"
            ? ` ${className}`
            : `btn p-0 m-0 d-flex align-items-center ${className}`
        }
        style={{
          ...style,
        }}
        type="button"
        {...rest}
      >
        {children}
      </button>
    );
  }
);
